<template>
  <transition name="modal">
    <div class="sef-modal-mask" v-if="show">
      <div
        id="cardnotif"
        class="card notif"
        :style="{ width: jsondata && jsondata.length > 0 ? '80%' : '35%' }"
      >
        <div class="card-header">
          <div class="card-load-title">
            <p style="margin-left: 4px">{{ title }}</p>
          </div>
          <div class="btn-actions-pane-right">
            <div class="btn-group-sm btn-group" role="group">
              <a href="#" class="active btn btn-focus" @click="doAction(false)">
                <i class="scf-close"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="card-body-container">
            <!-- contenu du popup -->
            <div class="modal-body">
              <!-- First row: Load Configuration -->
              <div class="row mb-3 align-items-center">
                <div class="col-info">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="inputFileClickEvent"
                  >
                    {{ $t("pages.Client.SelectFile") }}
                  </button>
                  <input
                    type="file"
                    ref="file"
                    style="display: none"
                    accept=".xls,.xlsx,.csv"
                    @change="selectFile"
                  />
                  <p class="card-load-info" v-if="jsondata.length == 1" >{{jsondata.length}}{{ $t("pages.Client.ClientReady") }}</p>
                  <p class="card-load-info" v-else-if="jsondata.length > 1">{{jsondata.length}}{{ $t("pages.Client.ClientsReady") }}</p>
                </div>
              </div>

              <!-- Added Table -->
              <div v-if="showTable">
                <table class="table table-bordered">
                  <thead>
                    <th v-if="addedClients.length > 0" class="tableFileTitle">{{ $t('pages.Client.ClientsAdded') }}</th>
                    <th v-if="notAddedClients.length > 0" class="tableFileTitle">{{ $t('pages.Client.ClientsAlreadyInDB') }}</th>
                  </thead>
                  <tbody>
                    <th class="tr-right" v-if="addedClients.length > 0">
                      <tr class="tableFileID" v-if="addedClients.length === 0"></tr>
                      <tr class="tableFileID" v-for="client in addedClients" :key="client">{{ client }}</tr>
                    </th>
                    <th v-if="notAddedClients.length > 0">
                      <tr class="tableFileID" v-if="notAddedClients.length === 0"></tr>
                      <tr class="tableFileID" v-else v-for="client in notAddedClients" :key="client">{{ client }}</tr>
                    </th>
                  </tbody>
                </table>
              </div>

              <!-- Second row: Export Configuration -->
              <p
                class="alert alert-warning alert-dismissible d-flex align-items-center fade show"
                v-if="(!jsondata || jsondata.length === 0) && showTable == false"
              >
                      <strong class="mx-2">
                        {{ $t("pages.Client.Warning") }}</strong
                      >
                      {{
                        $t("pages.Client.TereIsNoConfiguration") ||
                        "Veuillez charger une configuration."
                      }}
                    <button @click="downloadEmptyModel" type="button" class="Btn" style="margin-left:1%">
                      <svg class="svgIcon" viewBox="0 0 384 512" height="1em" xmlns="http://www.w3.org/2000/svg"><path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"></path></svg>
                      <span class="icon2"></span>
                      <span class="tooltip"> {{
                                            $t("pages.Client.Download")  
                                          }}</span>
                    </button>
                </p>
            <!-- end content of popup -->
          </div>
        </div>
        <div class="modal-footer" v-if="['create', 'edit'].includes(fromPage)">
          <button
           v-if="showTable == false"
            type="button"
            class="btn btn-primary"
            @click="doAction(false)"
          >
            {{ $t("common.cancel") }}
          </button>
          <button
           v-if="showTable == false"
            type="button"
            :disabled="!hasChanged && !showTable"
            class="btn btn-primary"
            @click="SendFile(this.jsondata)"
          >
            {{ $t("pages.Client.validate") }}
          </button>
          <button
           v-if="showTable == true"
            type="button"
            class="btn btn-primary"
            @click="doAction(false)"
          >
            {{ $t("pages.Client.confirm") }}
          </button>
        </div>
        <div
          v-else
          class="modal-footer"
          style="justify-content: center !important"
        >
          <button type="button" class="btn btn-primary" @click="close()">
            {{ $t("pages.Client.ok") }}
          </button>
        </div>
      </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { defineComponent, computed } from "vue";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import ClientService from "../services/ClientService";

export default defineComponent({
  name: "formModalClientFile",
  inject: ["accessToken"],
  components: { },
  data() {
    return {
      modalShow: false,
      showTable: false,
      error: true,
      noData: true,
      updated: true,
      hasChanged: false,
      parametersChanged: false,
      currentScope: this.$jwt.scope,
      culture: computed(() => this.$i18n.locale),
      clientService: new ClientService(this.$jwt.token, this.$jwt.scope),
      popupOpen: false, // État pour gérer l'ouverture/fermeture de la popup
      jsondata: [],
      addedClients: [],
      notAddedClients: [],
      expectedHeaders: ["Client Name","Project Code","Keycloak Realm","Status","Time Zone","Language / Culture","Unauthorized Associations","GDPR","Curve API","Number of Days","Levels / Zones","Comment","Services Assigned to the Client"],
      expectedStatus: ["In Migration", "Double Run", "Disabled", "Active", "Inactive", "Migrating", "DoubleRun"],
      expectedGDPR: ["Yes", "No"],
      expectedUnauthorizedAssociations: ["PDS", "PDS-Emetteur", "PDS-Compteur", "PDS-Emetteur-Compteur", "SP", "SP-Transmitter", "SP-Meter", "SP-Transmitter-Meter"],
      businessActs: [],
      expectedTimezones: [],
      expectedAPICurves: [],
      expectedCultures: ["en-GB"],
      parsingErrors: []
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    client: {
      type: String,
      required: true,
    },
    fromPage: {
      required: false,
      default: "create",
    }
  },

  mounted() {
      this.clientService
      .getParameters()
      .then((responseParams) => {
        responseParams.clientApiCurves.forEach(element => {
          this.expectedAPICurves.push(element.externalId);
          this.expectedAPICurves.push(element.description);
        });

        responseParams.timezones.forEach(element => {
          this.expectedTimezones.push(element.id);
          this.expectedTimezones.push(element.name);
        });

        responseParams.clientCultures.forEach(element => {
          this.expectedCultures.push(element.code);
          this.expectedCultures.push(element.description);
        });

        this.businessActs = responseParams.businessActs;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  created() {
  },
  methods: {
    doAction(isTrue) {
      if (isTrue === true) {
        // Clic sur Valider - envoyer les donnu00e9es modifiu00e9es au composant parent
        console.log(
          "🚀 Envoi des donnu00e9es du composant FormModalOrg au parent (clientForm)",
          this.jsondata
        );
      } else {
        // Clic sur Annuler
        console.log("🔙 Annulation des modifications");
        
          // Si aucune donnu00e9e n'a u00e9tu00e9 ru00e9cupu00e9ru00e9e de la base de donnu00e9es, ru00e9initialiser le modu00e8le
          console.log("🗑️ Ru00e9initialisation du modu00e8le");
          this.jsondata = [],
          this.$emit("update:show");

        // Ru00e9initialiser les indicateurs de modification
        this.hasChanged = false;
        this.parametersChanged = false;
        this.showTable = false;
      }
    },

    prepareBusinessActs(businessActs) {
      if (Array.isArray(businessActs))
        return businessActs.map((ba) => { ba.display = this.$t(`businessActs.${ba.trKey}`); return ba; })
      let transformedBusinessActs = [];
      Object.keys(businessActs).forEach((k) => {
        const item = {
          trKey: k,
          businessAct: businessActs[k],
          display: this.$t(`businessActs.${k}`),
        }
        transformedBusinessActs.push(item);
      });
      return transformedBusinessActs;
    },

    close() {
      // Fermeture du popup - traiter comme une annulation
      console.log("🔒 Fermeture du popup - annulation des modifications");
      
        // Si aucune donnu00e9e n'a u00e9tu00e9 ru00e9cupu00e9ru00e9e de la base de donnu00e9es, ru00e9initialiser le modu00e8le
        console.log("🗑️ Ru00e9initialisation du modèle");
        this.jsondata = [],
        this.$emit("update:show");
      
      // Ru00e9initialiser les indicateurs de modification
      this.hasChanged = false;
      this.showTable = false;
      this.notAddedClients = [];
      this.addedClients = [];
      this.parametersChanged = false;
      this.parsingErrors = [];
    },

    downloadEmptyModel() {
      const aoa = [this.expectedHeaders]; // Only the header row, no data

      const worksheet = XLSX.utils.aoa_to_sheet(aoa);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Clients");

      XLSX.writeFile(workbook, "Template Clients file.xlsx");
    },

    //*Load, validate the clients file and prepare the formData to be sended
    async selectFile() {
      this.jsondata = [];
      this.showTable = false;
      this.notAddedClients = [];
      this.addedClients = [];
      this.file = this.$refs.file.files[0];
      if (!this.file) return;
      try {
        await this.UploadCostumersFile();
      } catch (err) {
        console.error('File read error:', err);
      }
    },

    inputFileClickEvent() {
      console.log(this.appVersion);
      const elem = this.$refs.file;

      elem.click();
    },

    cancel() {
      this.intialization();
      this.$refs.file.value = null;
    },

  //*Imports the file data to a client object, it has diferent processes depending if the file is XLSX or CSV
  async UploadCostumersFile() {
    this.parsingErrors = [];
    this.headerError = false;
    if (!this.file) {
      return;
    }
    const fileName = this.file.name.toLowerCase();
    const self = this;
    //If the file is .csv
    if (fileName.endsWith('.csv')) {
      const reader = new FileReader();
      reader.onload = function (e) {
        const text = e.target.result;
        self.jsondata = self.parseCsvToClients(text);
        //If there are errors, we show the user instead of continuing
        if(self.parsingErrors.length > 0){
          self.showErrorsToUser();
          self.hasChanged = false;
        }
        else if(self.jsondata.length > 0)
          self.hasChanged = true;
    };
      reader.readAsText(this.file);
    }
    //If the file is .xlsx
    else if (fileName.endsWith('.xlsx')) {
      const reader = new FileReader();
      reader.onload = function (e) {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        //We check for header errors
        const headers = self.extractHeader(worksheet);
        var headerError = self.checkHeaders(headers);
        if(headerError){
          self.jsondata = [];
          self.hasChanged = false;
        }else{
          const json = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
          //We check if the json is empty before continuing, for .xlsx, the lenght must be greater than 0 to be valid
          if(!self.checkObjectLenght(json, 0)){
            self.jsondata = [];
            self.hasChanged = false;
            return;
          }
          var i = 1;
          json.forEach(line => {
            var client = self.transformRowToClient(line, i);
            if(!client){
              i++;
            }else{
              self.jsondata.push(client);
              i++;
            }

            if(self.parsingErrors.length > 0){
              self.showErrorsToUser();
              self.jsondata = [];
              self.hasChanged = false;
            }
            else
              self.hasChanged = true;

          });
          //self.jsondata = json.map(self.transformRowToClient);
        }
      }
      reader.readAsArrayBuffer(this.file);
    } else {
      alert("Veuillez sélectionner un fichier Excel (.xls ou .xlsx) or CSV.");
      return;
    }
  },

  //*Extracts the file headers
  extractHeader(ws) {
    const headers = []
    const columnCount = XLSX.utils.decode_range(ws['!ref']).e.c + 1
    for (let i = 0; i < columnCount; ++i) {
      headers[i] = ws[`${XLSX.utils.encode_col(i)}1`].v
    }
    return headers
  },

  //*Parse the csv data to a client objects
  parseCsvToClients(csvText) {
      const lines = csvText.split('\n').filter(line => line.trim());
      const headers = lines[0].split(';').map(h => h.trim());
      //We check that all headers are correct
      var headerError = this.checkHeaders(headers);
      if(headerError)
        return [];
      
      //We check that the file is not empty. For csv, if the lenght is 1, its not vali because it only includes the headers
      var valid = this.checkObjectLenght(lines, 1);
      if(!valid)
        return [];

      const clients = [];
      for (let i = 1; i < lines.length; i++) {      
        const row = lines[i].split(';').map(cell => cell.trim());
        //This is to eliminate the pesky " that slip at the beginning of the end of the csv line
        row[0] = row[0].slice(1);
        row[row.length-1] = row[row.length-1].substring(0, row[row.length-1].length - 1);
        const obj = {};
        headers.forEach((header, idx) => obj[header] = row[idx] || '');
        var client = this.transformRowToClient(obj, i);
        if(client)
          clients.push(client);
      }
      return clients;
    },

    //*Checks that the object has the expected length
    checkObjectLenght(object, length)
    {
      if (object.length == length) {
          //   console.warn("Aucune donnée trouvée dans la feuille.");
          Swal.fire({
            icon: "error",
            title: "",
            text: this.$t("pages.Client.ExcelImport.EmptyFiles"),
            customClass: {
              popup: "swal-custom-zindex",
            }
          });
          return false;
      }
      return true;
    },

    //*Transform the current line to a client object
    transformRowToClient(obj, i) {
      this.checkErrors(obj, i);
      
      //If there are error, we return null
      if(this.parsingErrors.length>0)
        return null;

      //Else we continue forward and fill the object
      //We do the transformation for the forbidenBusinessActs
      var cc = fillBusinessActs(obj, this.businessActs);

      var tempBussinessActs = obj['Unauthorized Associations'] ? obj['Unauthorized Associations'].split(',').map(a => a.trim()) : [];
      if(tempBussinessActs.length == 0){
        cc.ForbiddenBusinessActs = [];
      }else{
        var alreadyUsed = [];
        tempBussinessActs.forEach(ba => {
          if(alreadyUsed.includes(ba)){
            console.log("transformRowToClient ~ BusinessAct " + ba + "is already included in the file. Skipping it.")
          }else{
            if(ba == "SP" || ba == "PDS"){
              alreadyUsed.push("SP");
              alreadyUsed.push("PDS");
              cc.ForbiddenBusinessActs = cc.ForbiddenBusinessActs.concat(this.businessActs.Pds);
            }
            else if(ba == "SP-Transmitter" || ba == "PDS-Emetteur"){
              alreadyUsed.push("SP-Transmitter");
              alreadyUsed.push("PDS-Emetteur");
              cc.ForbiddenBusinessActs = cc.ForbiddenBusinessActs.concat(this.businessActs.PdsSensor);
            }
            else if(ba == "SP-Meter" || ba == "PDS-Compteur"){
              alreadyUsed.push("SP-Meter");
              alreadyUsed.push("PDS-Compteur");
              cc.ForbiddenBusinessActs = cc.ForbiddenBusinessActs.concat(this.businessActs.PdsTransmitter);
            }
            else if(ba == "SP-Transmitter-Meter" || ba == "PDS-Emetteur-Compteur"){
              alreadyUsed.push("SP-Transmitter-Meter");
              alreadyUsed.push("PDS-Emetteur-Compteur");
              cc.ForbiddenBusinessActs = cc.ForbiddenBusinessActs.concat(this.businessActs.PdsTransmitterSensor);
            }
          }
        });
      }

      var client = {
        name: obj['Client Name'].trim(),
        externalId: obj['Project Code'].trim(),
        keycloak: obj['Keycloak Realm']?.replace(/[^a-zA-Z0-9-_]/g, ''),
        status: this.expectedStatus.includes(obj['Status'].trim()) ? obj['Status'].trim() : 'In Migration',
        timezone:  this.expectedTimezones[this.expectedTimezones.indexOf(obj['Time Zone'].trim())-1],
        culture: obj['Language / Culture'].trim(),
        configuration: cc,
        clientConfiguration: JSON.stringify(cc),
        gdpr: obj['GDPR'] === 'Yes',
        apiCurve: this.expectedAPICurves.includes(obj['Curve API'].trim()) ? this.expectedAPICurves[this.expectedAPICurves.indexOf(obj['Curve API'].trim())-1] : this.expectedAPICurves[0],
        daysNumber: obj['Number of Days'] ? parseInt(obj['Number of Days'], 10) : null,
        levelsNumber: 0,
        levels: obj['Levels / Zones'] ? obj['Levels / Zones'].split(',').map(a => a.trim()) : [],
        services: obj['Services Assigned to the Client'] ? obj['Services Assigned to the Client'].split(',').map(s => s.trim()) : [],
        comment: obj['Comment'] || '',
        hirarchicalConfiguration: null,
        hierarchyContent:	[],
      }

      switch(client.status){
        case "In Migration":
          client.status = "Migrating";
          break;
        case "Disabled":
          client.status = "Inactive";
          break;
        case "Double Run":
          client.status = "DoubleRun";
          break;
      }

      client.levelsNumber = client.levels.length;
      return client;

      function fillBusinessActs(obj, businessActs){
        var config = { ForbiddenBusinessActs:[] }
        var tempBussinessActs = obj['Unauthorized Associations'] ? obj['Unauthorized Associations'].split(',').map(a => a.trim()) : [];
        if(tempBussinessActs.length == 0){
          config.ForbiddenBusinessActs = [];
        }else{
          var alreadyUsed = [];
          tempBussinessActs.forEach(ba => {
            if(alreadyUsed.includes(ba)){
              console.log("transformRowToClient ~ BusinessAct " + ba + "is already included in the file. Skipping it.")
            }else{
              alreadyUsed.push(ba);
              if(ba == "SP" || ba == "PDS")
                config.ForbiddenBusinessActs.concat(businessActs.Pds);
              else if(ba == "SP-Transmitter" || ba == "PDS-Emetteur")
                config.ForbiddenBusinessActs.concat(businessActs.PdsSensor);
              else if(ba == "SP-Meter" || ba == "PDS-Compteur")
                config.ForbiddenBusinessActs.concat(businessActs.PdsTransmitter);
              else if(ba == "SP-Transmitter-Meter" || ba == "PDS-Emetteur-Compteur")
                config.ForbiddenBusinessActs.concat(businessActs.PdsTransmitterSensor);
            }
          });
        }
        return config;
      }
    },



    SendFile(clientList){
     // Afficher le message Sweetalert pendant la cru00e9ation
     const loadingSwal = Swal.fire({
        title: this.$t("pages.Client.creatingClients"),
        text: this.$t("pages.Client.pleaseWait"),
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      
      //TODO: OPTIMIZE
      // Optimiser les donnu00e9es envoyu00e9es pour u00e9viter l'erreur 413 Payload Too Large
      // const optimizedClient = this.optimizeClientData(client);
      this.clientService
        .createFromList(clientList)
        .then((response) => {
          // Fermer le message Sweetalert
          // We quit the button
          this.jsondata = [];
          this.hasChanged = false;
          loadingSwal.close();
          if(response.response === undefined){
            Swal.fire({
              title: this.$t("pages.Client.APIError"),
              text:  this.$t("pages.Client.APIErrorInfo"),
              icon: "error",
              showConfirmButton: true,
            });
          }
          else if (response.errorCode == "AllClientExternalIdExists") {
            this.notAddedClients = response.response.value[0];
            this.addedClients = response.response.value[1];
            this.showTable = true;
            // Afficher un message d'erreur spu00e9cifique
            Swal.fire({
              title: this.$t("pages.Client.ClientsAddedError"),
              text:  this.$t("pages.Client.ClientsAddedErrorInfo"),
              icon: "error",
              showConfirmButton: true,
            });
          } else {
            this.notAddedClients = response.response.value[0];
            this.addedClients = response.response.value[1];
            this.showTable = true;
            // Afficher un message de succu00e8s
            Swal.fire({
              icon: 'success',
              title: this.$t("pages.Client.createSuccess"),
              text: this.$t("pages.Client.clientsCreatedSuccessfully"),
              timer: 2000,
            });
            
            // Rediriger vers la liste des clients 
            // setTimeout(() => {
            //   this.goToList();
            // }, 2000);
          }
          console.log(response);
        })
        .catch((error) => {
          // Fermer le message Sweetalert et afficher une erreur
          loadingSwal.close();
          
          Swal.fire({
            icon: 'error',
            title: this.$t("pages.Client.createError"),
            text: error.message || this.$t("pages.Client.errorOccurred"),
          });
          
          console.log(error);
        });

    },

    //ERROR CONTROL

    addError(message){
      this.parsingErrors.push(message);
      console.log("🚀 ~ transformRowToClient ~ " + message);
    },

    checkErrors(obj, i){
      if(!obj["Client Name"])
        this.addError(this.$t("pages.Client.ExcelImport.DataMissingError", {name: this.$t("pages.Client.name"), line: i}));

      if(!obj["Project Code"])
        this.addError(this.$t("pages.Client.ExcelImport.DataMissingError", {name: this.$t("pages.Client.code"), line: i}));
      
      if(!obj["Keycloak Realm"])
        this.addError(this.$t("pages.Client.ExcelImport.DataMissingError", {name: this.$t("pages.Client.keycloak"), line: i}));
      
      if(!obj["Status"])
        this.addError(this.$t("pages.Client.ExcelImport.DataMissingError", {name: this.$t("pages.Client.status"), line: i}));
      else if(!this.expectedStatus.includes(obj['Status'].trim()))
        this.addError(this.$t("pages.Client.ExcelImport.DataIncorrectError", {name: this.$t("pages.Client.status"), line: i}));

      if(!obj["Time Zone"])
        this.addError(this.$t("pages.Client.ExcelImport.DataMissingError", {name: this.$t("pages.Client.timeZone"), line: i}));
      else if(!this.expectedTimezones.includes(obj['Time Zone'].trim()))
        this.addError(this.$t("pages.Client.ExcelImport.DataIncorrectError", {name: this.$t("pages.Client.timeZone"), line: i}));
      
      if(!obj["Language / Culture"])
        this.addError(this.$t("pages.Client.ExcelImport.DataMissingError", {name: this.$t("pages.Client.culture"), line: i}));
      else if(!this.expectedCultures.includes(obj['Language / Culture'].trim()))
        this.addError(this.$t("pages.Client.ExcelImport.DataIncorrectError", {name: this.$t("pages.Client.culture"), line: i}));

      if(!obj["GDPR"])
        this.addError(this.$t("pages.Client.ExcelImport.DataMissingError", {name: this.$t("pages.Client.rgpd"), line: i}));
      else if(!this.expectedGDPR.includes(obj['GDPR'].trim()))
        this.addError(this.$t("pages.Client.ExcelImport.DataIncorrectError", {name: this.$t("pages.Client.rgpd"), line: i}));

      if(!obj["Curve API"])
        this.addError(this.$t("pages.Client.ExcelImport.DataMissingError", {name: this.$t("pages.Client.apiCurve"), line: i}));
      else if(!this.expectedAPICurves.includes(obj['Curve API'].trim()))
        this.addError(this.$t("pages.Client.ExcelImport.DataIncorrectError", {name: this.$t("pages.Client.apiCurve"), line: i}));

      var Unauthorized = obj['Unauthorized Associations'].split(',').map(a => a.trim());
      if(Unauthorized.length > 0){
        Unauthorized.forEach(e => {
          this.tempUA = e;

          if(!this.expectedUnauthorizedAssociations.includes(e))
            this.addError(this.$t("pages.Client.ExcelImport.DataUAIncorrectError", {name: this.$t("pages.Client.forbiddenBusinessActs"), line: i, ua: e}));
        });
      }

      //There must be at least one level per client
      var Levels = obj['Levels / Zones'].split(',').map(a => a.trim());
      if(Levels.length == 1 && Levels[0] == "")
        this.addError(this.$t("pages.Client.ExcelImport.DataZonesError", {line: i}));  
      else{
        var alreadyUsed = []
        Levels.forEach(level => {
          if(alreadyUsed.includes(level)){
            var message = this.$t("pages.Client.ExcelImport.LevelNameRepeated", {name: level, line: i});
            if(!this.parsingErrors.includes(message))
              this.addError(message);  
            return;
          }else{
            alreadyUsed.push(level);
          }
        });
      }    
    },


    checkHeaders(headers){
      console.log("🚀 ~ UploadCostumersFile ~ expectedHeaders:", this.expectedHeaders);
        const sameLength = headers.length === this.expectedHeaders.length;
        const allMatch = this.expectedHeaders.every((h) =>
        headers.includes(h)
        );
        console.log("🚀 ~ UploadCostumersFile ~ allMatch:", allMatch);

        if (!sameLength || !allMatch) {
        Swal.fire({
          icon: "error",
          title: this.$t("pages.Client.ExcelImport.HeaderMismatchTitle"),
          html: this.$t("pages.Client.ExcelImport.HeaderMismatchMessage_HTML", {
            found: headers.join(", "),
            expected: this.expectedHeaders.join(", ")
          }),
          customClass: {
            popup: "swal-custom-zindex",
          },
        });
        return true;
       }
       return false;
    },

    showErrorsToUser(){
      var message = "";
      this.parsingErrors.forEach(error => {
        message+= '<p align="center">' + error + "</p>";
      });

      Swal.fire({
              title: this.$t("pages.Client.FileParsingError"),
              html:  message,
              icon: "error",
              showConfirmButton: true,
            });
    },

  },
  watch: {
    currentScope(newVal) {
      if (newVal) {
        this.clientService = new ClientService(this.$jwt.token, newVal);
      }
    },
    accessToken(newVal) {
      if (newVal) {
        this.clientService = new ClientService(newVal, this.currentScope);
      }
    },
    show: function (newValue) {
      this.modalShow = newValue;
    },
  },
});
</script>

<style scoped>
.disabledClass {
  cursor: inherit !important;
  color: #ccc !important;
}

.sef-modal-mask {
  position: fixed;
  /*z-index: 9998; */
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: 0.1 0.3s ease;
}

.card {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: "D-DIN";
  width: auto;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.card.full {
  width: 80%;
}

.card.notif .card-title {
  margin-right: 15px !important;
}

.card.notif .modal-footer {
  justify-content: center;
}

.card.confirmation {
  width: 30%;
}

.modal-footer .btn-primary {
  background-color: #eee !important;
  padding: 5px 30px;
  font-weight: bold;
  font-size: 14px;
  border: 1px solid #e2e6ec !important;
}

.card .card-header {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  border-bottom-width: 1px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 5px;
  padding-left: 10px;
  height: 35px;
  background-color: #bbdbfd;
  border-radius: 6px 6px 0px 0px;
  font-size: 12pt;
  font-weight: bold;
  border-bottom: 2px solid #1973d2;
  box-sizing: unset !important;
}
.card .card-header p {
  margin-top: revert !important;
  margin-bottom: revert !important;
}

.card-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 0 !important;
}

.card-load-title {
  color: #030f40;
  font-size: 18px;
  font-family: "D-DIN-500";
  font-weight: 800;
  margin: 20px 0;
}

.card-load-info {
  color: #030f40;
  font-size: 18px;
  font-family: "D-DIN-500";
  font-weight: 800;
  width: 15%;
  float: right;
  align-content: center;
}

.card .btn-actions-pane-right {
  margin-left: auto;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  align-items: baseline;
}

.card .card-header .btn-group,
.btn-group-vertical {
  position: relative;
  display: -ms-inline-flexbox;
  display: inline-flex;
  vertical-align: middle;
}
.card .card-header a {
  text-decoration: none;
}
.card .card-header a.btn.btn-focus i {
  /* margin-left: 10px;
        margin-right: 10px; */
  color: #1973d2;
  font-size: 12pt;
}
.card .card-header a.btn.btn-focus i:hover {
  opacity: 0.5;
}

.card-body {
  padding: unset !important;
}
.card .card-body-container {
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  overflow: hidden;
  overflow-y: auto;
  background: #f4f6fb;
  max-height: 680px;
  padding-bottom: 10px;
}

.card.full .card-body-container {
  height: 70vh;
}

.card .notif .card-body-container {
  height: auto;
}

.card.confirmation .card-body-container {
  height: 100px;
}

.card .modal-footer {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: space-between !important;
  padding: 1rem;
  border-top: 1px solid #e9ecef;
  background: #f4f6fb;
}
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.5s;
}

.btn-primary {
  color: #030f40;
  background-color: #eeeeee;
  border: 1px solid #030f40 !important;
}
.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}
.btn-primary:hover {
  color: #030f40;
  background-color: #dddddd;
  border-color: #030f40;
}

.modal-footer > :not(:last-child) {
  margin-right: 0.25rem;
}
.modal-enter,
.modal-leave-to {
  opacity: 0;
}
.modal-information {
  font-weight: normal;
}

.zone-container {
  display: flex;
  margin: 10px 0px;
}

.zone-container input {
  margin-left: 10px;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0;
  border-radius: 4px !important;
  border: 1.5px solid #030f40 !important;
}
</style>
<style scoped>
/* Adapted from .card and .card.notif to .modal-content */

/* Modal overlay remains similar */
.modal-overlay {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}

/* New modal-content styled based on card.notif */
.modal-content {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: "D-DIN", sans-serif;
  width: 310px; /* same as card width */
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
}

/* Adapted header from .card .card-header */
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 10px;
  height: 35px;
  background-color: #bbdbfd;
  border-bottom: 2px solid #1973d2;
  font-size: 12pt;
  font-weight: bold;
}

/* Optional: style for header title if needed */
.modal-title {
  margin: 0;
}

/* Adapted body from .card-body-container */
.modal-body {
  padding: 10px;
  /* font-family: Menlo, Consolas, monospace; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f4f6fb;
  /* overflow-y: auto; */
  max-height: 680px;
}

/* Adapted footer style (if needed) */
.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 1rem;
  border-top: 1px solid #e9ecef;
  background: #f4f6fb;
}

/* Button styling (if you want to mimic your previous btn-primary) */
.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  cursor: pointer;
  border: 1px solid transparent;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.btn-primary {
  color: #030f40;
  background-color: #eeeeee;
  border: 1px solid #030f40 !important;
}
.btn-primary:hover {
  background-color: #dddddd;
  border-color: #030f40;
}

.Information {
  padding: 20px;
  background-color: #2196f3;
  color: white;
}

.warn,
.warn::before,
.warn::after {
  position: relative;
  padding: 0;
  margin: 0;
}

.warn {
  font-size: 36px;
  color: transparent;
}

.warn.warning {
  display: inline-block;

  top: 0.225em;

  width: 1.15em;
  height: 1.15em;

  overflow: hidden;
  border: none;
  background-color: transparent;
  border-radius: 0.625em;
}

.warn.warning::before {
  content: "";
  display: block;
  top: -0.08em;
  left: 0em;
  position: absolute;
  border: transparent 0.6em solid;
  border-bottom-color: #fd3;
  border-bottom-width: 1em;
  border-top-width: 0;
  box-shadow: #999 0 1px 1px;
}

.warn.warning::after {
  display: block;
  position: absolute;
  top: 0.3em;
  left: 0;
  width: 100%;
  padding: 0 1px;
  text-align: center;
  font-family: "Garamond";
  content: "!";
  font-size: 0.65em;
  font-weight: bold;
  color: #333;
}
.swal-custom-zindex {
  z-index: 10000 !important;
}

.alert-container {
  position: relative;
  padding: 1rem 1.5rem 1rem 3rem;
  border: 1px solid #b3d9ff;
  border-left: 4px solid #2196f3;
  background-color: #e6f2ff;
  color: #0b3954;
  /* border-radius: 0.5rem; */
  margin: 1rem 0;
  /* font-family: sans-serif; */
  transition: all 0.3s ease;
  margin-right: 12px;
  margin-left: 19px;
}

.alert-icon {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.2rem;
  color: #2196f3;
}

.alert-close-label {
  position: absolute;
  right: 1rem;
  top: 1rem;
  font-size: 1.2rem;
  cursor: pointer;
  color: #0b3954;
}

input[type="checkbox"].alert-toggle {
  display: none;
}

input[type="checkbox"].alert-toggle:checked + .alert-container {
  display: none;
}
#cardnotif {
  min-width: 1400px;
  max-width: 1600px;
}

/* From Uiverse.io by vinodjangid07 */
.Btn {
  width: 50px;
  height: 50px;
  border: none;
  border-radius: 50%;
  background-color: rgb(27, 27, 27);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transition-duration: 0.3s;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.11);
}

.svgIcon {
  fill: rgb(214, 178, 255);
}

.icon2 {
  width: 18px;
  height: 5px;
  border-bottom: 2px solid rgb(182, 143, 255);
  border-left: 2px solid rgb(182, 143, 255);
  border-right: 2px solid rgb(182, 143, 255);
}

.tooltip {
  position: absolute;
  right: -105px;
  opacity: 0;
  background-color: rgb(12, 12, 12);
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition-duration: 0.2s;
  pointer-events: none;
  letter-spacing: 0.5px;
}

.tooltip::before {
  position: absolute;
  content: "";
  width: 10px;
  height: 10px;
  background-color: rgb(12, 12, 12);
  background-size: 1000%;
  background-position: center;
  transform: rotate(45deg);
  left: -5%;
  transition-duration: 0.3s;
}

.Btn:hover .tooltip {
  opacity: 1;
  transition-duration: 0.3s;
}

.Btn:hover {
  background-color: rgb(150, 94, 255);
  transition-duration: 0.3s;
}

.Btn:hover .icon2 {
  border-bottom: 2px solid rgb(235, 235, 235);
  border-left: 2px solid rgb(235, 235, 235);
  border-right: 2px solid rgb(235, 235, 235);
}

.Btn:hover .svgIcon {
  fill: rgb(255, 255, 255);
  animation: slide-in-top 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

.tableFileTitle {
  width: 50%;
  background: #77b7fc;
  color: #01184a;
  padding: 0.5rem;
  box-shadow: none;
  border: black;
  outline: none;
  backface-visibility: hidden;
  transform: translateZ(0);
  text-align: center;
}

.tableFileID {
  width: 100%;
  display: block;
  background: white;
  color: 01184a;
  margin: 0;
  padding: 0;
  box-shadow: none;
  border: black;
  outline: none;
  backface-visibility: hidden;
  transform: translateZ(0);
  text-align: center;
}

.tr-left{
  border-inline-start : 3px solid black;
}

.tr-right{
  border-inline-end : 3px solid black;
}

.col-info{
  flex: 0 0 auto;
  width: 100%;
}

@keyframes slide-in-top {
  0% {
    transform: translateY(-10px);
    opacity: 0;
  }

  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}
</style>
